import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { useRecaptchaAction } from "../lib/useRecaptchaAction";
import { RecaptchaDisclosure } from "../components/RecaptchaDisclosure";
import { toast } from "sonner";

export default function RegisterPage() {
    const { registerCompany } = useAuth();
    const { getToken } = useRecaptchaAction();
    const nav = useNavigate();
    const [form, setForm] = useState({
        company_name: "",
        company_email: "",
        manager_name: "",
        manager_email: "",
        password: "",
    });
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

    const onSubmit = async (e) => {
        e.preventDefault();
        if (form.password.length < 8) {
            toast.error("A palavra-passe deve ter pelo menos 8 caracteres");
            return;
        }
        setBusy(true);
        try {
            const recaptcha_token = await getToken("register");
            await registerCompany({ ...form, recaptcha_token });
            toast.success("Empresa registada com sucesso!");
            nav("/app/company");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen grid lg:grid-cols-2" data-testid="register-page">
            <aside className="relative bg-[#0d1628] text-white hidden lg:flex flex-col justify-between p-12 grain">
                <Link to="/" className="font-display text-3xl tracking-tight">IHTP</Link>
                <div>
                    <div className="font-display text-4xl xl:text-5xl leading-[1.1] max-w-lg">
                        Uma nova forma de liderar equipas. Comece por registar a sua organização.
                    </div>
                    <div className="label-caps text-white/60 mt-8">Plataforma IHTP para empresas</div>
                </div>
                <div className="label-caps text-white/50">Acesso reservado</div>
            </aside>

            <section className="flex items-center justify-center px-6 md:px-12 py-16">
                <div className="w-full max-w-md">
                    <h1 className="font-display text-4xl text-[#0d1628]">Registar empresa</h1>
                    <p className="text-sm text-[#52525b] mt-3">A sua conta fica criada como Gestor de Empresa.</p>

                    <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="register-form">
                        <div>
                            <label className="label-caps block mb-2">Nome da empresa</label>
                            <input required className="input-clean" value={form.company_name} onChange={set("company_name")} data-testid="reg-company-name" />
                        </div>
                        <div>
                            <label className="label-caps block mb-2">Email da empresa</label>
                            <input type="email" required className="input-clean" value={form.company_email} onChange={set("company_email")} data-testid="reg-company-email" />
                        </div>
                        <div>
                            <label className="label-caps block mb-2">O seu nome</label>
                            <input required className="input-clean" value={form.manager_name} onChange={set("manager_name")} data-testid="reg-manager-name" />
                        </div>
                        <div>
                            <label className="label-caps block mb-2">O seu email</label>
                            <input type="email" required className="input-clean" value={form.manager_email} onChange={set("manager_email")} data-testid="reg-manager-email" />
                        </div>
                        <div>
                            <label className="label-caps block mb-2">Palavra-passe</label>
                            <input type="password" required minLength={8} className="input-clean" value={form.password} onChange={set("password")} data-testid="reg-password" />
                            <div className="text-xs text-[#52525b] mt-2">Mínimo 8 caracteres</div>
                        </div>
                        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="register-submit">
                            {busy ? "A registar..." : "Registar empresa"}
                        </button>
                    </form>

                    <div className="mt-8 text-sm">
                        Já tem conta? <Link to="/login" className="link-underline text-[#0d1628]">Entrar</Link>
                    </div>
                    <RecaptchaDisclosure />
                </div>
            </section>
        </div>
    );
}
